
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:630px;">
    <div class="modal-header">
      <h4 class="modal-title">Notify Transition Lead(s) of Project Rejection</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row">
        <div class="form-group col">
          <label class="required" for="rejectReasons">Please give the reason for rejecting this project.</label>
          <textarea class="form-control" id="rejectReasons" [(ngModel)]="rejectReasons" name="rejectReasons" rows="6"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="reject()">Reject</button>
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>